import { Suspense, useContext, useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { SidebarProvider } from "../context/SidebarContext";
import Main from "./Main";
import ThemedSuspense from "../components/ThemedSuspense";
import {
	Outlet,
	useLocation,
	useNavigate,
	useOutlet,
	useParams,
} from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Spinner from "../components/Spinner";
import { decodeToken } from "react-jwt";
import Header from "../components/Navbar/Header";
import AdminHeader from "../components/AdminHeader/AdminHeader";

const ProtectedLayout = () => {
	const token = localStorage.getItem("userToken");
	const navigate = useNavigate();
	const outlet = useOutlet();
	let location = useLocation();
	const { companyId } = useParams();

	const canAccess = async () => {
		const user = JSON.parse(localStorage.getItem("userInfo"));
		const decoded = await decodeToken(token);

		// SUPER_ADMIN can access everything
		if (decoded.role === "SUPER_ADMIN") return;

		// Non-super admins cannot access administrator routes
		if (location.pathname.includes("administrator")) {
			if (decoded.role === "AGENT") {
				navigate(`/company/${user.company._id}/agent/dashboard`);
			} else {
				navigate(`/company/${user.company._id}/dashboard`);
			}
			return;
		}

		// AGENT can only access agent routes
		if (decoded.role === "AGENT") {
			const isAgentRoute = location.pathname.includes("/agent/");
			if (!isAgentRoute) {
				navigate(`/company/${user.company._id}/agent/dashboard`);
			}
			return;
		}

		// ADMIN/ADMIN 1 should not access agent routes
		if (location.pathname.includes("/agent/")) {
			navigate(`/company/${user.company._id}/dashboard`);
		}
	};
	useEffect(() => {
		if (!token) navigate("/");
		else canAccess();
	}, [outlet]);

	if (!token) return navigate("/");
	return (
		<SidebarProvider>
			<div className={`flex h-screen bg-gray-50`}>
				<Sidebar />
				<div className="flex flex-col flex-1 w-full min-w-0">
					{/* We can place a navbar above main if we use a nav */}
					<Main>
						<Suspense fallback={<ThemedSuspense />} />
						{companyId ? <Header /> : <AdminHeader />}

						{outlet}
					</Main>
				</div>
			</div>
		</SidebarProvider>
	);
};

export default ProtectedLayout;
